import { useEffect } from "react";
import pages from "../constants/pages";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { setAccessToken, signInMember } from "../redux/slices/memberSlice";

function useAuthToken() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const auth = new URLSearchParams(location.search).get("auth");

    if (auth) {
      const isGuardLogin =
        new URLSearchParams(location.search).get("guard_login") === "true";
      sessionStorage.setItem("authToken", auth);
      localStorage.setItem("authToken", auth);
      if (isGuardLogin) {
        sessionStorage.setItem("auth_token_with_guard", auth);
        localStorage.setItem("auth_token_with_guard", auth);
      }
      dispatch(setAccessToken(auth));

      dispatch(
        signInMember({
          authToken: auth,
          newAuthToken: true,
        })
      );
    }
  }, []);
}

export default useAuthToken;
